<!-- page wrapper -->
<div class="file-preview-wrapper">
    <mat-card>
        <!-- title -->
        <mat-card-title id="wrapper">
            <div>
                <!-- <mat-icon class="file-preview-header-icon">
                    image
                </mat-icon> -->
                <span class="status-dialog-title" cdkFocusInitial>Profile Picture Preview</span>
            </div>
            <button mat-button class="toolbar-icon-button dialog-closeicon" matTooltip="Close" (click)="onCancel($event)">
                <mat-icon class="material-icons dialog-closeicon">
                    close
                </mat-icon>
            </button>
        </mat-card-title>
        <!-- content -->
        <mat-card-content>
            <!-- profile picture -->
            <img [src]="src" alt="Profile Picture" class="profile-pic">
        </mat-card-content>
    </mat-card>
</div>